import * as React from 'react';
import { DATA_ATTRIBUTES, DATA_HOOKS } from './constants';
import { ChevronDown } from '@wix/wix-ui-icons-common/on-stage';
import { TPAComponentsContext, } from '../TPAComponentsConfig';
import { classes, st } from './DropdownNativeSelect.st.css';
import { Spinner, SpinnerTypes } from '../Spinner';
class DropdownNativeSelectComponent extends React.Component {
    onSelect(e) {
        const { selectedOption: prevSelectedOption } = this.props;
        const optionId = e.target.value;
        if ((prevSelectedOption && prevSelectedOption.id) === optionId) {
            return;
        }
        const selectedOption = this.props.options.find(({ id }) => id === optionId);
        this.props.onSelect(selectedOption);
    }
    renderOptions(hasPlaceholder) {
        const { placeholder, options } = this.props;
        return (React.createElement(React.Fragment, null,
            hasPlaceholder && (React.createElement("option", { "data-hook": DATA_HOOKS.placeholderOption, value: "", disabled: true, hidden: !options.length }, placeholder)),
            options.map((option, i) => !option.divider ? (React.createElement("option", { key: i, value: option.id, disabled: !option.isSelectable }, option.value)) : null)));
    }
    renderOptionIcon() {
        return (React.createElement("div", { className: classes.optionIcon }, this.props.selectedOption.icon));
    }
    getDataAttributes() {
        const { error } = this.props;
        return {
            [DATA_ATTRIBUTES.error]: error,
        };
    }
    render() {
        const { disabled, readOnly, selectedOption, error, errorMessage, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, 'aria-required': ariaRequired, id: dropdownId, className, name, errorComponent, newErrorMessage, isLoading, 'loading-aria-label': loadingAriaLabel, } = this.props;
        const { rtl } = this.context;
        const hasPlaceholder = !selectedOption || !selectedOption.value;
        const shouldRenderIcon = selectedOption && !!selectedOption.icon;
        const nativeSelectStyles = st(classes.root, {
            error,
            disabled,
            readOnly,
            placeholder: hasPlaceholder,
            icon: shouldRenderIcon,
            rtl,
            fullWidth: true,
        }, className);
        return (React.createElement("div", { className: classes.wrapper, onClick: (e) => readOnly && e.preventDefault(), onMouseDown: (e) => readOnly && e.preventDefault(), onKeyDown: (e) => readOnly && e.preventDefault() },
            React.createElement("select", { ...this.getDataAttributes(), defaultValue: "", ...(selectedOption && { value: selectedOption.id }), id: dropdownId, onChange: (e) => !readOnly && this.onSelect(e), "data-hook": DATA_HOOKS.nativeSelect, ref: this.props.innerRef, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, "aria-required": ariaRequired, disabled: disabled, name: name, "aria-readonly": readOnly, className: nativeSelectStyles }, this.renderOptions(hasPlaceholder)),
            shouldRenderIcon ? this.renderOptionIcon() : null,
            error && errorMessage && !newErrorMessage && errorComponent,
            React.createElement("div", { className: classes.suffixContainer }, isLoading ? (React.createElement(Spinner, { className: classes.loader, "data-hook": DATA_HOOKS.loader, type: SpinnerTypes.slim, "aria-label": loadingAriaLabel })) : (React.createElement(ChevronDown, { className: classes.arrowIcon })))));
    }
}
DropdownNativeSelectComponent.contextType = TPAComponentsContext;
export const DropdownNativeSelect = React.forwardRef((props, ref) => (React.createElement(DropdownNativeSelectComponent, { ...props, innerRef: ref })));
//# sourceMappingURL=DropdownNativeSelect.js.map